import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { Grid } from '@mui/material'

import { InputNormalizers, TextFieldControl } from '../../../../components/form'
import { NewB2BFormState } from '../../qrs.types.ts'

export const TotalTaxField = (): React.ReactElement | null => {
  const { watch, resetField } = useFormContext<NewB2BFormState>()
  const takeTaxField = watch('takeTax')

  useEffect(() => {
    if (takeTaxField === 'false') {
      resetField('totalTaxAmount')
    }
  }, [takeTaxField])

  return takeTaxField === 'true' ? (
    <Grid item xs={12}>
      <TextFieldControl<NewB2BFormState>
        name="totalTaxAmount"
        fullWidth
        label="Сумма НДС"
        normalize={InputNormalizers.positiveNumbersOnly()}
      />
    </Grid>
  ) : null
}
